import { render } from "./LogDetails.vue?vue&type=template&id=4c641096&scoped=true"
import script from "./LogDetails.vue?vue&type=script&lang=js"
export * from "./LogDetails.vue?vue&type=script&lang=js"

import "./LogDetails.vue?vue&type=style&index=0&id=4c641096&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c641096"]])

export default __exports__